
import React from 'react';
// Fix: Use namespace import to bypass missing exported member errors in react-router-dom
import * as ReactRouterDom from 'react-router-dom';
import { PeopleImportWizard } from '../features/imports/PeopleImportWizard';
import { OrgImportWizard } from '../features/imports/OrgImportWizard';
import { RosterImportWizard } from '../features/imports/RosterImportWizard';
import { AttendanceImportWizard } from '../features/imports/AttendanceImportWizard';
import { EngagementImportWizard } from '../features/imports/EngagementImportWizard';
import { SessionImportWizard } from '../features/imports/SessionImportWizard';

const { useSearchParams, Navigate } = ReactRouterDom as any;

/**
 * Dispatcher for Specialized Import Workflows.
 * Routes to the correct wizard based on query parameters.
 */
const ImportWizard: React.FC = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const engagementId = searchParams.get('engagementId');
  const sessionId = searchParams.get('sessionId');

  // Case 1: Operational Attendance Sync (Specific Session)
  if (sessionId) {
    return <AttendanceImportWizard />;
  }

  // Case 2: Strategic Roster Sync (Specific Engagement)
  if (engagementId) {
    return <RosterImportWizard />;
  }

  // Case 3: Standalone Registry Sync
  switch (type) {
    case 'people':
      return <PeopleImportWizard />;
    case 'orgs':
      return <OrgImportWizard />;
    case 'engagements':
      return <EngagementImportWizard />;
    case 'sessions':
      return <SessionImportWizard />;
    default:
      return <Navigate to="/" replace />;
  }
};

export default ImportWizard;
